<div class="page-with-shadow">
    <app-page-header 
        [title]="pageTitle" 
        [description]="pageDescription"> 
    </app-page-header>
    <mat-divider></mat-divider>
    <form (ngSubmit)="onSubmit()" #projectForm="ngForm" class="col">
        <app-project-template 
            [project]="newProject"
            (isValidChanged)="isValidChanged($event)">
        </app-project-template>

        <div class="d-flex justify-content-end">
            <button type="button" 
                class="btn btn-default" 
                (click)="onCancel()">
                Cancel
            </button>
            <button type="submit" 
                class="btn btn-primary margin-left-md" 
                [disabled]="!isValid">
                Create new project
            </button>
        </div>
    </form>
</div>